module.exports = __webpack_public_path__ + "5b8d52c28a5352916e4bae9b45089904.svg";